const { String } = require('stdlib/String')
const { getDateInstance } = require('./getDateInstance')

/**
 * Visszaadja az aktuális időt.
 * @param {string | number | Date} tmp - A paraméter, amiből az idő rész kell.
 * @example
 * '2021-01-01T12:34:56.789Z' => '12:34:56'
 * @returns {string} Az ISO idő: hh:ii:ss.
 */
module.exports.getTime = function getTime (tmp) {
  const date = getDateInstance(tmp)

  const time = [
    String.pad(date.getHours()),
    String.pad(date.getMinutes()),
    String.pad(date.getSeconds())
  ].join(':')

  return time
}
